import styled from 'styled-components';
import algoliasearch from 'algoliasearch/lite';
import { Configure, InstantSearch } from 'react-instantsearch-dom';
import { CustomAutocomplete } from './AutoComplete';
import { easeInOutSine, fadeInAnim, fadeOutAnim, unMountAfterAnim } from '../../styles/animations';
import { usePageLocale } from '../../../hooks/usePageLocale';
import { PRODUCTS_INDEX_NAME } from '../../../constants/algolia';

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_APP_ID,
  process.env.GATSBY_ALGOLIA_SEARCH_KEY
);

const Background = styled.section`
  width: 100vw;
  height: 100vh;
  background: var(--blue-1-alpha);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${({ $autoComplete }) =>
      $autoComplete ? fadeInAnim : fadeOutAnim}
    300ms ${easeInOutSine} forwards;
`;

export const AutoCompletePopup = ({
  $autoComplete,
  setAutoComplete,
  closePopup,
  clickOutsideRef,
  inputRef,
}) => {
  const { locale } = usePageLocale();

  return (
    <Background
      ref={clickOutsideRef}
      $autoComplete={$autoComplete}
      onAnimationEnd={() => unMountAfterAnim($autoComplete, setAutoComplete)}
    >
      <InstantSearch indexName={PRODUCTS_INDEX_NAME} searchClient={searchClient}>
        <Configure filters={`locale:${locale}`} />
        <CustomAutocomplete
          inputRef={inputRef}
          $autoComplete={$autoComplete}
          closePopup={closePopup}
          setAutoComplete={setAutoComplete}
        />
      </InstantSearch>
    </Background>
  );
};
